import React from 'react';

import { Skeleton, Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import commonStyles from '../../styles/common.module.scss';

export const ReviewSkeleton: React.FC = () => {
  const isMobile = useIsMobile();

  return (
    <div className={commonStyles.blockWrapper}>
      <Skeleton>
        <Space justify={'space-between'}>
          <Skeleton.Paragraph width={55} />
          <Skeleton.Paragraph width={11} />
        </Space>
        <Space justify={'space-between'}>
          <Space size={12}>
            <Skeleton.Paragraph width={15} />
            <Skeleton.Paragraph width={15} />
          </Space>
          <Skeleton.Paragraph width={32} />
        </Space>
        <Space direction="vertical" align="start" size={20}>
          <Skeleton.Paragraph width={98} />
          <Skeleton.Paragraph width={90} />
          <Skeleton.Paragraph width={94} />
        </Space>
        <Space justify={'space-between'} direction={isMobile ? 'vertical' : 'horizontal'} size={isMobile ? 16 : 0}>
          <Space size={12} align="start">
            <Skeleton.Avatar />
            <Space direction={'vertical'} size={4}>
              <Skeleton.Paragraph width={39} />
              <Space size={8}>
                <Skeleton.Paragraph width={28} />
                <Skeleton.Paragraph width={28} />
              </Space>
            </Space>
          </Space>
          <Space size={8} align={'center'} justify={isMobile ? 'start' : 'end'}>
            <Skeleton.Paragraph width={14} />
            <Skeleton.Paragraph width={14} />
            <Skeleton.Paragraph width={14} />
          </Space>
        </Space>
      </Skeleton>
    </div>
  );
};
